export function PanelSkeleton() {
  return <div className="h-full animate-pulse bg-surface-2/40" data-testid="panel-skeleton" />;
}

export function PanelError({ onRetry }: { onRetry: () => void }) {
  return (
    <div className="h-full flex flex-col items-center justify-center gap-2 text-xs text-gray-500">
      <span>Data unavailable</span>
      <button className="text-kinetica-400 hover:underline" onClick={onRetry}>retry</button>
    </div>
  );
}

// Empty series hint names the likely rollout cause (design §6): the Alloy
// serial label may not be deployed on that device yet.
export function PanelEmpty() {
  return (
    <div className="h-full flex items-center justify-center px-4 text-center text-xs text-gray-500">
      No data in range — if this device was recently set up, its telemetry serial label may not be deployed yet.
    </div>
  );
}
